export const employeeEntryqualificationApi = {
    heading:[
        {
            head:"Qualification"
        },
        {
            head:"Subject"
        },
        {
            head:"Institute"
        },
        {
            head:"Board"
        },
        {
            head:"Passing Year"
        },
        {
            head:"Result"
        },
       
    ],
    data:[
        {
           qualification:"HSC"
        },
        {
            qualification:"SSC"
        },
        {
            qualification:"JSC"
        },
    ]
}
export const employeeEntryexperienceApi = {
    heading:[
        {
            head:"Company Name"
        },
        {
            head:"Location"
        },
        {
            head:"Position"
        },
        {
            head:"Responsibility"
        },
        {
            head:"Start Date"
        },
        {
            head:"End Date"
        },
       
    ],
    data:[
        {
           compname:"Dhaka College"
        },
        {
            compname:"Zazira school"
        },
        {
            compname:"Zazira school"
        },
    ]
}

